import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'dashboard_amc.my_contracts.title',
  },
  contractsAndGuarantees: {
    id: 'dashboard_amc.contracts_and_guarantees',
  },
  claims: {
    id: 'dashboard_amc.claims',
  },
  Actif: {
    id: 'dashboard_auto.mes_contracts.actif',
  },
  Encours: {
    id: 'dashboard_auto.mes_contracts.encours',
  },
  id: {
    id: 'dashboard_amc.contract.id',
  },
  policyNumber: {
    id: 'dashboard_amc.contract.policy_number',
  },
  organisme: {
    id: 'amc.details.organisme.name.bis',
  },
  submitHealthRequest: {
    id: 'dashboard_amc.submit_health_request',
  },
  followUpMyRequests: {
    id: 'dashboard_amc.follow_up_my_requests',
  },
  declareBeneficiary: {
    id: 'Home_text_Health_declarer_un_beneficiaire',
  },
  dmoDelarations: {
    id: 'dmo_Home_text_Health_mes_declaration',
  },
  base: {
    id: 'refund.type.base',
  },
  complementaire: {
    id: 'refund.type.complementaire',
  },
  drugstores: {
    id: 'Home.text.Health.pharmacies_de_garde',
  },
  aideSoignant: {
    id: 'Home.text.Health.aide_soignant',
  },
});
